import { assayQueryKeys } from '@/config/queryKeys';
import { apiClient } from '@/lib/api-client';
import type { AssayRunConfig, AssayPublicGetMany, ProteoformResultsTableConfig } from '@/types';

/**
 * Fetch all active assays, suitable for populating a dropdown.
 */
export async function fetchAssays(): Promise<AssayPublicGetMany[]> {
  const result = await apiClient.get<AssayPublicGetMany[]>(assayQueryKeys.endpoints.list());
  return result ?? [];
}

/**
 * Fetch run configuration (species/sample-count options + controls) for every active assay.
 * One call pre-loads everything the Run create/edit page needs once an assay is picked.
 */
export async function fetchAssayRunConfigs(): Promise<AssayRunConfig[]> {
  const result = await apiClient.get<AssayRunConfig[]>(assayQueryKeys.endpoints.runConfigs());
  return result ?? [];
}

/**
 * Fetch the proteoform results table column layout for a specific assay.
 */
export async function fetchProteoformResultsTableConfig(assayId: string): Promise<ProteoformResultsTableConfig> {
  const result = await apiClient.get<ProteoformResultsTableConfig>(
    assayQueryKeys.endpoints.proteoformResultsTableConfig(assayId),
  );
  // apiClient.get() returns `T | null` specifically for a 204 (No Content) response — any
  // other falsy-but-not-null value would be a real payload (e.g. `0`), so check `=== null`.
  if (result === null) throw new Error(`No proteoform results table config returned for assay ${assayId}`);
  return result;
}
